import type { CaseEvent, CaseQuote } from "@/mocks/cases";

export const CaseTimeline = ({ events }: { events: CaseEvent[] }) => (
  <ol className="relative mt-6">
    <span className="absolute left-[9px] top-2 bottom-2 w-px bg-background-300" aria-hidden="true" />
    {events.map((event, index) => (
      <li key={`${event.date}-${index}`} className="relative pl-9 pb-8 last:pb-0">
        <span
          className={`absolute left-0 top-1 w-5 h-5 rounded-full border-2 flex items-center justify-center ${
            index === events.length - 1
              ? "bg-primary-500 border-primary-500"
              : "bg-background-50 border-primary-300"
          }`}
        >
          {index === events.length - 1 && (
            <span className="w-1.5 h-1.5 rounded-full bg-background-50" />
          )}
        </span>
        <p className="font-label text-xs font-bold text-primary-600 tracking-wide">
          {event.date}
        </p>
        <h4 className="mt-1 font-heading font-bold text-base md:text-lg text-foreground-950">
          {event.title}
        </h4>
        <p className="mt-1.5 text-sm md:text-base text-foreground-600 leading-relaxed">
          {event.description}
        </p>
      </li>
    ))}
  </ol>
);

export const CaseQuotes = ({ quotes }: { quotes: CaseQuote[] }) => (
  <div className="mt-6 space-y-4">
    {quotes.map((quote, index) => (
      <figure
        key={`${quote.date}-${index}`}
        className="p-4 md:p-6 rounded-lg bg-background-100 border-l-4 border-primary-400"
      >
        <blockquote className="text-sm md:text-base text-foreground-800 leading-relaxed">
          「{quote.text}」
        </blockquote>
        <figcaption className="mt-3 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="font-label font-bold text-primary-600">{quote.date}</span>
          <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900">
            来源类型：{quote.source}
          </span>
        </figcaption>
      </figure>
    ))}
  </div>
);